<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {ModelListSelect} from "vue-search-select";
import {mapGetters, mapActions, mapState} from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import ExcelExport from "@/components/ExcelExport.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables Purchases",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelExport
  },
  data() {
    return {
      title: "Consumables Purchase Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumables Purchase Report",
          active: true,
        },
      ],
      clientCurrentPage: 1,
      clientPerPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      returnData: {
        purchase_id: '',
        product_id: '',
        product_name: '',
        quantity: '',
        unit_price: '',
        batch: '',
        date: moment(new Date()).format("YYYY-MM-DD"),
        reason: '',
        mode: '',
        type: 0,
        filterdata: {}
      },
      deleteData: {
        id: "",
        filterdata: {}
      },
      editData: {
        id: "",
        filterdata: {}
      },
      amountError: "",
      modeError: "",

      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        branch_id: 0,
        product: '',
        invoiceno: ''
      },

      PurchaseQuantity: 0,
      is_uploading: false,
      QtyError: "",
      ReasonError: "",
      IsServerPaginated: true,
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("consumables", [
      "SaveStatus",
      "filterStatus",
      "ConsumablesPurchasesData",
      "ConsumablesPurchasesPagination",
      "ConsumablesPurchasesSummary",
      "Consumables"
    ]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "Branches", "branchid"]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings"]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("products", ["Products"]),

    rows() {
      return this.IsServerPaginated
          ? this.ConsumablesPurchasesPagination.total
          : (this.ConsumablesPurchasesData ? this.ConsumablesPurchasesData.length : 0);
    },

    currentPage: {
      get() {
        return this.IsServerPaginated ? this.ConsumablesPurchasesPagination.current_page : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      }
    },

    perPage: {
      get() {
        return this.IsServerPaginated ? this.ConsumablesPurchasesPagination.per_page : this.clientPerPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.serverPerPage = value;
          this.handlePageChange(1);
        } else {
          this.clientPerPage = value;
        }
      }
    },

    totals() {
      return this.ConsumablesPurchasesSummary || {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
        totalBalance: 0,
      };
    }
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPurchases: "consumables/fetchConsumablesPurchases",
      FetchProducts: "consumables/fetchConsumables",
      EditPurchase: "consumables/editConsumablePurchase",
      DeletePurchase: "consumables/deleteConsumablePurchase",
      FetchModes: "setting/fetchPaymentOptions",
      SaveReturn: "consumables/returnConsumablePurchase",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchSuppliers: "stock/fetchSuppliers",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },
    thousandSeperator(m) {
      if (m !== "" && m !== undefined && m !== 0 && m !== "0" && m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
      this.ReasonError = "";
      this.modeError = "";
    },
    resetDelete() {
      this.deleteData.id = "";
    },
    resetEdit() {
      this.editData.id = "";
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
      this.deleteData.filterdata = this.data;
    },
    editPurchase(modalId) {
      this.editData.filterdata = this.data;
      this.modal_id = modalId;
      this.EditPurchase(this.editData);
    },
    deletePurchase(modalId) {
      this.modal_id = modalId;
      this.DeletePurchase(this.deleteData);
    },
    closeModal(modalId) {
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    Showreturn_modal(purchase, detail) {
      this.PurchaseQuantity = detail.qty;
      this.returnData.purchase_id = purchase.id;
      this.returnData.product_id = detail.product_id;
      this.returnData.product_name = detail.product;
      this.returnData.unit_price = detail.SPrice;
      this.returnData.quantity = detail.qty;
      this.returnData.batch = detail.batch;

      let defaultop = this.PaymentOptions ? this.PaymentOptions.find(mode => mode.default == 1) : null;
      this.returnData.mode = defaultop ? defaultop.id : (this.PaymentOptions?.[0]?.id ?? 0);
    },
    resetSave() {
      // this.resetErrors();
      this.returnData.purchase_id = '';
      this.returnData.product_id = '';
      this.returnData.product_name = '';
      this.returnData.quantity = '';
      this.returnData.unit_price = '';
      this.returnData.batch = '';
      this.returnData.reason = '';
      this.returnData.date = moment(new Date()).format("YYYY-MM-DD");
      this.returnData.mode = '';
      this.modal_id = "";
    },
    Return_purchase(modalId) {
      this.modal_id = modalId;
      if (this.returnData.quantity > this.PurchaseQuantity) {
        this.QtyError = 'Quantity returned is greater than quantity purchased!';
        return;
      } else {
        this.QtyError = '';
      }
      if (this.returnData.reason == "") {
        this.ReasonError = 'Reason field is required';
        return;
      } 
      if (this.returnData.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.ReasonError = '';
      }
      this.returnData.filterdata = this.data;
      this.SaveReturn(this.returnData);
    },

    filterReport() {
      this.clientCurrentPage = 1;
      let payload = {...this.data};
      payload.page = 1;
      payload.per_page = this.serverPerPage;
      this.FetchPurchases(payload);
    },

    handlePageChange(newPage) {
      if (this.IsServerPaginated) {
        let payload = {
          ...this.data,
          page: newPage,
          per_page: this.serverPerPage
        };
        this.FetchPurchases(payload);
      }
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting the sales data. Please try again.",
        confirmButtonText: "OK",
      });
    },
  },
  created() {
    this.FetchPurchases(this.data);
    this.FetchModes();
    this.FetchGeneralSettings();
    this.FetchSuppliers();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <!-- Header -->
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{ business }}</h4><h4
        v-if="GeneralSettings.show_branchname == 1 && branch"><em
        v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{ branch }}</h4>
    </div>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Import Button & Branch Filter -->
            <div class="row">
              <div class="col-md-4 mb-2"></div>
              <div class="col-md-4"></div>
              <div class="col-md-4 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>
                <model-list-select
                    :list="Branches ? [ { id: 0, name: 'All Branches' }, ...Branches ] : []"
                    v-model="data.branch_id"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Branch"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>

            <!-- Export Button & Title -->
            <div class="row mt-4">
              <div class="col-6">
                <ExcelExport
                  endpoint="export_shoppurchases"
                  filename="shoppurchases_report.xlsx"
                  :payload="data"
                  button-text="Export"
                  button-variant="info"
                  icon-class="fas fa-download"
                  @export-error="handleExportError"
                />
              </div>
              <div class="col-md-6">
                <h3 class="card-title mb-2" v-html="title"></h3>
              </div>
            </div>

            <!-- Product Filter -->
            <div class="row">
              <div class="col-md-9"></div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                <model-list-select
                    :list="Consumables ? [ { id: '', name: 'All Products' }, ...Consumables ] : []"
                    v-model="data.product"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Product"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>

            <!-- Date, Supplier, Invoice Filters -->
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="data.datefrom" class="form-control" v-limit-future-date/>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="data.dateto" class="form-control" v-limit-future-date/>
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIERS</label>
                <model-list-select
                    :list="Suppliers ? [{id:'', name:'All Suppliers'}, ...Suppliers] : []"
                    v-model="data.supplier"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Supplier"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>INVOICE NO.</label>
                <input
                    class="form-control"
                    v-model="data.invoiceno"
                    placeholder="Enter Invoice No"
                />
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="SaveStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>

            <!-- Per Page & Search -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" v-if="!IsServerPaginated">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <!-- Table Area -->
            <div class="table-responsive mb-0">
                <table class="table table-striped table-bordered    table-responsive nowrap w-100 datatables">
                   <thead>
                    <tr>
                      <th>S/N</th>
                      <th>PRODUCT </th>                      
                      <th>QTY</th>
                      <th>PRICE</th>
                      <th
                        v-if="GeneralSettings && GeneralSettings.track_expiries"
                      >
                        BATCH
                      </th>
                      <th>RETURN</th>
                      <th>TOTAL</th>
                      <th>PAID</th>
                      <th>DISCOUNT</th>
                      <th v-if="GeneralSettings && GeneralSettings.capture_purchase_invoiceno">INVOICE NO</th>
                      <th>SUPPLIER</th>
                      <th>DATE</th>
                      <th>ACTIONS</th>
                    </tr>
                  </thead>
                   <tbody
                    v-if="
                      !SaveStatus &&
                      ConsumablesPurchasesData &&
                      ConsumablesPurchasesData.length > 0
                    "
                  >
                    <template v-for="(item, index) in ConsumablesPurchasesData">
                      <tr
                        v-for="(det, d) in item.items"
                        :key="`${item.id}-${d}`"
                      >
                        <td
                          v-if="d === 0"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                        >
                          {{ ConsumablesPurchasesPagination.from + index }}
                        </td>
                        <td :class="'purchase-row-end'">{{ det.product }}</td>                        
                        <td :class="'purchase-row-end'">
                          {{ det.qty }} {{ det.usymbol }}
                        </td>
                        <td :class="'purchase-row-end'">
                          {{
                            det.unitPrice ? thousandSeperator(det.unitPrice) : 0
                          }}
                        </td>
                        <td
                          v-if="
                            GeneralSettings && GeneralSettings.track_expiries
                          "
                          :class="'purchase-row-end'"
                        >
                          {{ det.batch }}
                        </td>
                        <td
                          :class="'purchase-row-end'"
                          >
                          <b-button
                            v-if="det.Returned == 1"
                            variant="secondary"
                            disabled
                          >
                            Returned
                          </b-button>
                          <b-button
                            v-else
                            v-b-modal.return-purchase-modal
                            @click="Showreturn_modal(item, det)"
                            variant="primary"
                          >
                            Return
                          </b-button>
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                        >
                          {{ thousandSeperator(item.totAmt) }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                        >
                          {{ thousandSeperator(item.amtPaid) }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                        >
                          {{ thousandSeperator(item.discount) }}
                        </td>                        
                        <td
                          v-if="d === 0 && GeneralSettings && GeneralSettings.capture_purchase_invoiceno"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                          
                        >
                          {{ item.invoiceno }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                        >
                          {{
                            item.supplier && item.supplier ? item.supplier : ""
                          }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                        >
                          {{ item.date }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.items.length"
                          :class="'purchase-row-end'"
                        >
                          <div>
                            <b-dropdown text="More Actions..." size="sm" class="btn-primary"
                                    v-if="MyUserPerm.modify_purchases == 1">
                          <b-dropdown-item
                              v-b-modal.delete-purchase-modal
                              v-if="MyUserPerm.delete_purchase == 1"
                              @click="showDeleteModal({item: item})">
                            <i class="fa fa-trash text-danger"></i> <span class="text-danger">Delete</span>
                          </b-dropdown-item>
                          <b-dropdown-item
                              v-if="MyUserPerm.edit_purchase == 1"
                              v-b-modal.edit-purchase-modal
                              @click="showEditModal({item: item})">
                            <i class="fa fa-edit text-primary"></i> <span class="text-primary">Edit</span>
                          </b-dropdown-item>
                        </b-dropdown>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>

                  <tbody v-if="SaveStatus">
                  <tr>
                    <td  :colspan="14" class="text-center">
                      <div class="text-warning my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading...</strong>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                  <!-- Empty State -->
                  <tbody v-if="!SaveStatus && (!ConsumablesPurchasesData || ConsumablesPurchasesData.length === 0)">
                  <tr>
                    <td :colspan="14" class="text-center">
                      No purchases found for the selected criteria.
                    </td>
                  </tr>
                  </tbody>
                </table>
            </div>

            <div class="row mt-2 font-weight-bold">
              <div class="col-md-3">
                <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(totals.totalAmount) }}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Paid: <span class="text-danger">{{ thousandSeperator(totals.totalPaid) }}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Discount: <span class="text-danger">{{ thousandSeperator(totals.totalDiscount) }}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Balance: <span class="text-danger">{{ thousandSeperator(totals.totalBalance) }}</span></h5>
              </div>
            </div>

            <!-- Pagination Controls -->
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Modals -->
            <b-modal id="return-purchase-modal" hide-footer @hidden="resetSave">
              <template #modal-title> Return {{ returnData.product_name }}</template>
              <div class="form-group mb-3">
                <label>Return Date</label>
                <div class="input-group">
                  <input
                      type="date"
                      placeholder="Enter Date"
                      class="form-control"
                      v-model="returnData.date"
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Quantity</label>
                <div class="input-group">
                  <input
                      type="number"
                      placeholder="Enter quantity"
                      class="form-control"
                      v-model="returnData.quantity"
                      @input="QtyError = ''"
                  />
                </div>
                <div class="text-danger" v-if="QtyError">
                  <em>{{ QtyError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Reason</label>
                <div class="input-group">
            <textarea
                type="text"
                placeholder="Enter reason"
                class="form-control"
                v-model="returnData.reason"
                @input="ReasonError = ''"
            ></textarea>
                </div>
                <div class="text-danger" v-if="ReasonError">
                  <em>{{ ReasonError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Payment Option</label>
                <div class="input-group">
                  <model-list-select
                      :list="PaymentOptions ? PaymentOptions : []"
                      v-model="returnData.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Mode"
                      @input="modeError = ''"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="modeError">
                  <em>{{ modeError }}</em>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-5">
                  <button
                      type="button"
                      class="btn btn-secondary"
                      @click="closeModal('return-purchase-modal')"
                  ><i class="fa fa-times"></i>
                    Close
                  </button>
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-5 d-flex justify-content-end">
                  <button
                      v-if="SaveStatus"
                      type="button"
                      class="btn btn-primary"
                      disabled><i class="fa fa-check"></i>
                    Submit & Exit
                    <b-spinner
                        variant="light"
                        small
                        label="Spinning"
                    ></b-spinner>
                  </button>
                  <button
                      v-else
                      type="button"
                      class="btn btn-primary"
                      @click="Return_purchase('return-purchase-modal')"
                  ><i class="fa fa-check"></i>
                    Submit & Exit
                  </button>
                </div>
              </div>
            </b-modal>

            <!-- Edit Purchase Modal -->
            <b-modal
                header-bg-variant="warning"
                header-text-variant="light"
                body-text-variant="warning"
                footer-bg-variant="warning"
                footer-text-variant="warning"
                id="edit-purchase-modal"
                hide-footer
                @hidden="resetEdit"
            >
              <template #modal-title> Edit Purchase</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to return and edit this Purchase? Click Proceed Button to Return Purchase for Editing.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('edit-purchase-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="editPurchase('edit-purchase-modal')"
                >
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Processing"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>

            <b-modal
                header-bg-variant="danger"
                header-text-variant="light"
                body-text-variant="danger"
                footer-bg-variant="danger"
                footer-text-variant="danger"
                id="delete-purchase-modal"
                hide-footer
                @hidden="resetDelete"
            >
              <template #modal-title> Delete Purchase</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Purchase? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-purchase-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deletePurchase('delete-purchase-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary, .page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}

.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
th {
  vertical-align: top;
  white-space: normal;
}
.item-container {
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.purchase-row-end {
  border-bottom: 1px solid black !important;
}
.item-container-btn {
  margin-bottom: 5px;
}
</style>